export const policyData = [
  {
    name: "Terms and Condition",
    route: "termsAndCondition",
    content: `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<title>Terms and Conditions</title>
</head>
<body>
<h1>Terms and Conditions</h1>

  <p>For the purpose of these Terms and Conditions, the terms <strong>"we"</strong>, <strong>"us"</strong>, <strong>"our"</strong> refer to <strong>J7 TECHNOLOGY SOLUTIONS PRIVATE LIMITED</strong>, whose registered office is located at:</p>
<address>
    11/54 J, Tenkasi Road, 7th Street, Alangulam,<br>
    Tirunelveli, Tamil Nadu – 627851
</address>

  <p>The terms <strong>"you"</strong>, <strong>"your"</strong>, <strong>"user"</strong>, or <strong>"visitor"</strong> refer to any individual or legal entity accessing our website or engaging with our services.</p>

  <p>By accessing our website or entering into a service agreement with us, you agree to be bound by the following terms and conditions:</p>

  <h2>1. Scope of Services</h2>
<p><strong>J7 TECHNOLOGY SOLUTIONS PRIVATE LIMITED</strong> provides software development, consulting, IT services, and related digital solutions. All engagements are governed by formal proposals or agreements, and the scope of work will be mutually defined and agreed upon.</p>

  <h2>2. Website Use</h2>
<p>The content on our website is for general information purposes only and is subject to change without prior notice.</p>
<p>We do not provide any warranty or guarantee regarding the accuracy, completeness, or suitability of the information and materials found on our website for any particular purpose.</p>
<p>Your use of any information or materials on our website is entirely at your own risk. It is your responsibility to ensure that our services meet your specific requirements.</p>

  <h2>3. Intellectual Property</h2>
<p>This website contains materials which are owned by or licensed to us. This includes, but is not limited to, the design, layout, branding, and all visual elements.</p>
<p>Reproduction, modification, or redistribution of any content from this website without prior written permission is strictly prohibited.</p>
<p>All third-party trademarks, logos, or brand names appearing on the website are acknowledged as the property of their respective owners.</p>

  <h2>4. Unauthorized Use</h2>
<p>Unauthorized use of this website or the information provided by us may give rise to a claim for damages and/or constitute a criminal offense.</p>
<p>You may not create a link to this website from another website or document without our prior written consent.</p>

  <h2>5. External Links</h2>
<p>From time to time, our website may include links to external websites. These are provided for your convenience and further information.</p>
<p>We do not endorse the content of linked websites and are not responsible for their availability or accuracy.</p>

  <h2>6. Payments & Transactions</h2>
<p>Payments for our services are governed by the terms specified in the respective proposals or service agreements.</p>
<p>We shall not be held liable for any loss or damage arising directly or indirectly from the decline of authorization for any transaction, due to the cardholder exceeding their pre-set limit or for any other reason related to the payment gateway.</p>

  <h2>7. Dispute Resolution</h2>
<p>Any dispute arising out of the use of our website, services, or transactions with <strong>J7 TECHNOLOGY SOLUTIONS PRIVATE LIMITED</strong> will be governed by the laws of India.</p>
<p>Jurisdiction for all disputes shall be the courts of Tirunelveli, Tamil Nadu, unless otherwise mutually agreed.</p>
</body>
</html>`,
  },
  {
    name: "Privacy Policy",
    route: "privacyPolicy",
    content: `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<title>Privacy Policy</title>
</head>
<body>
<h1>Privacy Policy</h1>

  <p>This Privacy Policy outlines how <strong>J7 TECHNOLOGY SOLUTIONS PRIVATE LIMITED</strong> collects, uses, and protects any information that you provide when visiting our website or engaging with our services.</p>

  <p>We are committed to safeguarding your privacy. If we ask you to provide information by which you can be identified while using this website, it will only be used in accordance with this Privacy Policy.</p>

  <p><strong>J7 TECHNOLOGY SOLUTIONS PRIVATE LIMITED</strong> may update this policy periodically. We recommend checking this page from time to time to stay informed about any changes.</p>


  <h2>Information We Collect</h2>
<p>We may collect the following information:</p>
<ul>
<li>Name</li>
<li>Contact information including email address and phone number</li>
<li>Demographic information such as postcode, preferences, and interests</li>
<li>Other relevant information for surveys, offers, or service improvement</li>
</ul>


  <h2>How We Use the Information</h2>
<p>The information we collect helps us better understand your needs and improve our services. We may use the data for:</p>
<ul>
<li>Internal record keeping</li>
<li>Improving our services and offerings</li>
<li>Sending promotional emails about new services, special offers, or other updates</li>
<li>Conducting market research through email, phone, or mail</li>
<li>Customizing the website according to your preferences</li>
</ul>


  <h2>Data Security</h2>
<p>We are committed to ensuring that your information is secure. To prevent unauthorized access or disclosure, we have implemented appropriate technical and organizational safeguards.</p>


  <h2>How We Use Cookies</h2>
<p>A cookie is a small file placed on your computer's hard drive with your consent. It helps analyze web traffic and tailors website operations to your preferences.</p>

  <p>We use traffic log cookies to:</p>
<ul>
<li>Identify which pages are visited</li>
<li>Analyze data to improve website functionality and user experience</li>
<li>Maintain statistical records only (data is deleted afterward)</li>
</ul>

  <p>Cookies do not give us access to your computer or any personal data beyond what you choose to share.</p>

  <p>You can accept or decline cookies. Most web browsers accept cookies by default, but you can modify your browser settings to decline them if you prefer. Please note, this may limit the full functionality of the website.</p>


  <h2>Controlling Your Personal Information</h2>
<p>You may choose to limit the use of your personal information in the following ways:</p>
<ul>
<li>Opt-out by unchecking marketing communication checkboxes when filling forms on our website</li>
<li>Change your preferences at any time by writing to or emailing us at <a href="mailto:hello@jseven.in">hello@jseven.in</a></li>
</ul>

  <p>We will never sell, distribute, or lease your personal information to third parties without your permission or unless required by law.</p>
<p>With your consent, we may send promotional information about third-party services we think you may find useful.</p>


  <h2>Updating Your Information</h2>
<p>If you believe any information we hold is incorrect or incomplete, please contact us at:</p>

  <address>
<strong>Address:</strong><br>
    11/54 J, Tenkasi Road, 7th Street, Alangulam,<br>
    Tirunelveli, Tamil Nadu – 627851<br><br>
<strong>Phone:</strong> <a href="tel:04633291912">04633 291912</a><br>
<strong>Email:</strong> <a href="mailto:hello@jseven.in">hello@jseven.in</a>
</address>

  <p>We will promptly correct any incorrect information.</p>
</body>
</html>`,
  },
  {
    name: "Cancellation & Refund Policy",
    route: "cancellationAndrefund",
    content: `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<title>Cancellation & Refund Policy</title>
</head>
<body>
<h1>Cancellation & Refund Policy</h1>

  <p>At <strong>J7 TECHNOLOGY SOLUTIONS PRIVATE LIMITED</strong>, we deliver specialized software development and IT services tailored to client-specific needs. Our approach is grounded in transparency, collaboration, and a commitment to delivering measurable value through every engagement.</p>

  <h2>Cancellation Policy</h2>
<p>As a service-based company, we operate on a milestone-based or time-based billing model.</p>
<p>Invoices are generated only after the successful delivery of agreed services or project milestones.</p>
<p>Therefore, once an invoice is raised, cancellation is not permitted.</p>

  <h3>Invoice Adjustments</h3>
<p>While invoices cannot be cancelled, we understand that in rare and exceptional situations, unforeseen factors may arise.</p>
<p>In such cases, clients may initiate a formal request for invoice review. Any modification or reduction to the invoice amount is solely at the discretion of <strong>J7 TECHNOLOGY SOLUTIONS PRIVATE LIMITED</strong> and must be mutually agreed upon in writing.</p>
<p>These decisions are made case-by-case, taking into account the scope of work, delivery status, and contractual terms.</p>

  <h2>Refund Policy</h2>
<p>As our services are customized, time-bound, and non-reversible in nature, we do not offer refunds once services have been rendered and invoiced.</p>
<p>However, we are committed to quality and client satisfaction. If there are any concerns about the work delivered, clients are encouraged to contact us within <strong>5 working days</strong> of invoice receipt. Our team will review the issue and, if necessary, provide appropriate corrections or clarifications.</p>

  <h2>Contact & Support</h2>
<p>For any queries or concerns related to invoices or service delivery, please contact:</p>
<ul>
<li><strong>Email:</strong> <a href="mailto:berkin.thomas@jseven.in">berkin.thomas@jseven.in</a></li>
<li><strong>Phone:</strong> <a href="tel:04633291912">04633 291912</a></li>
<li><strong>Business Hours:</strong> 9:00 am to 7:00 pm</li>
</ul>
</body>
</html>`,
  },
];
